import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ThumbUpOffAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"thumb_up_off_alt"}/>
}
